var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 5.5C15.809 5.5 18.757 8.17 19.194 11.612C20.945 12.038 22.25 13.619 22.25 15.5C22.25 17.706 20.456 19.5 18.25 19.5H7.25C4.493 19.5 2.25 17.257 2.25 14.5C2.25 12.32 3.859 10.292 6.007 9.65C7.1 7.111 9.494 5.5 12.25 5.5ZM18.25 17.5C19.353 17.5 20.25 16.603 20.25 15.5C20.25 14.397 19.353 13.5 18.25 13.5H17.25V12.5C17.25 9.743 15.007 7.5 12.25 7.5C10.144 7.5 8.399 8.773 7.696 10.824L7.504 11.382L6.923 11.484C5.449 11.743 4.25 13.096 4.25 14.5C4.25 16.154 5.596 17.5 7.25 17.5H18.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7456 11.5L11.7461 13.4996L10.7464 12.4998C10.4702 12.2237 10.0226 12.2236 9.74634 12.4996C9.47002 12.7758 9.46994 13.2237 9.74617 13.4999L11.7461 15.5L14.7458 12.5001C15.022 12.2238 15.0219 11.7759 14.7456 11.4998C14.4694 11.2237 14.0217 11.2238 13.7456 11.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCheck);
export default __webpack_public_path__ + "static/media/cloud_check.1090ccf23239f663407945f99ce605f8.svg";
export { ForwardRef as ReactComponent };